package views.coletor

import androidx.compose.runtime.*
import ffButton0
import ffButtonDiv
import ffEspVerticalMil
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Fatloteitem
import ffMsgAviso
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import utils.ff.Companion.println0
import views.componentes.*
import kotlin.js.Date

class col007 {

    private val _t = "col007" //lote de separação
    private var llote: List<Fatloteitem>? = null
    private var olote: Fatloteitem? = null

    fun show() {

        ffMsgAviso("")

        lbTitulo!!.innerText = "007 - Conferência do lote de separação"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
        }
    }

    @Composable
    fun body() {

        val _lote = remember { mutableStateOf(gsInput(_t)) }
        val _table1Controler = remember { mutableStateOf(gsInput(_t)) }

        val _btAbrir = remember { mutableStateOf(gsInput(_t)) }

        val _produto = remember { mutableStateOf(gsInput(_t)) }

        //ffInput1("Número do lote", _lote, "NS", 999999, 100, false)
        ffInput44("Número do lote", _lote, "NS", 0, 100, false, {}, {})
        if (_lote.text().equals("0")) {
            SideEffect { _lote.setFocusSimples(true) }
            _lote.text("")
        }
        _lote.onKeyPressENTER() { o ->
            if (!_lote.text().equals("")) {
                _lote.enabled(false)
                listarFatlote(_lote, _table1Controler)
                _produto.setFocus()
            }
        }

//        val bReturn = _lote.onKeyPressENTER()
//        if (bReturn) {
//            println0("zuza9988 onKeyPressENTER gsKey=${gsKey} $bReturn")
//
//            if (!_lote.text().equals("")) {
//                _lote.enabled(false)
//                listarFatlote(_lote, _table1Controler)
//                _produto.setFocus()
//
//            }
//        }

        ffButton0("Abrir", {
            _btAbrir.enabled(false)
            _produto.enabled(true)
            _produto.setFocusSimples(true)

        }, 100)
        if (_btAbrir.enabled()) {
            //println0("zuza9988 onKeyPressENTER gsKey=${gsKey} ${_btAbrir.enabled()}")
            ffEspVerticalMil(5)
            _lote.setFocusSimples()
            //ffEspHorizontalMil(10)
        } else {
            //_inventario.enabled(false)
            listarFatlote(_lote, _table1Controler)
            val _qtd = remember { mutableStateOf(gsInput(_t)) }
            //_qtd.text_set()
            val _inProdutoQtd = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inProdutoQtd", _textAnt = "1")) }

            //ffInput1("Informe o produto", _produto, "NS", 0, 100, false)

            ffEspVerticalMil(5)
            ffInput44("Informe o produto", _produto, "NS", 0, 100, false, {}, {})
            _produto.onKeyPressENTER {
                //_qtd.text("1")
                //println0("zuza0999 ${_produto.text()}")
                println0(llote)

                val o = Fatloteitem().reg(_produto.text(), llote!!)
                println0(o)
                if (o == null) {
                    ffMsgAviso("Item não encontrado no lote!", true)
//                    ffAudio().ffPlayBeep(false)
                } else {
                    ffMsgAviso("")
                    ffAudio().ffPlayBeep(true)
                    _produto.text(o.FATITE_PRODUTO.ffZeroLeft(6) + " - " + o.OO_DESCRCOMPLETA)
                    _produto.enabled(false)

                    _inProdutoQtd.text("")
                    if (o.OO_UNIDVENDA.compareTo(1.0) > 0) {
                        if (o.OO_TIPO.equals("C"))
                            _inProdutoQtd.text("CAIXA COM " + o.OO_UNIDVENDA.toString() + " UNIDADES")
                        if (o.OO_TIPO.equals("D"))
                            _inProdutoQtd.text("DISPLAY COM " + o.OO_UNIDVENDA.toString() + " UNIDADES")
                        _inProdutoQtd.textAnt(o.OO_UNIDVENDA.toString())
                    }
                    _qtd.span("Qtd: ${o.FATITE_QTCONT}")
                    _qtd.text("1")
                    _qtd.setFocus()
                    _qtd.select()
                }
            }

            if (!_produto.text().equals("")) {
                Div {
                    if (!_inProdutoQtd.text().equals("") && !_produto.text().equals("")) {
                        //println0("zuza9999 vai criar o input= ${_inProdutoQtd.text()}")
                        ffInput1("", _inProdutoQtd, "NS", 0, 100, false)
                        //_inProdutoQtd.text("CAIXA COM ${_inProduto.text()}")
                        _inProdutoQtd.enabled(false)
                    } else if (_produto.equals("")) {
                        _inProdutoQtd.text("")
                    }
                }
            }

            //println0("zuza99 chegou aqui")
            Div({ classes("form-group", "input-group") }) {

                //val _gravar = remember { mutableStateOf(false) }

                println0("mont88 objeto da quantidade ${_qtd.carregado()}")
                //ffInput44("Quantidade: ", _qtd, "N", 9, 45, true)
                ffInputN("Quantidade: ", _qtd, "N", 9, 45, true)
                _qtd.text_set()

                _qtd.onKeyPressENTER { o ->
                    gsKey = "gravar"
                }

                ffButtonDiv("Gravar", { _qtd.keySet("Enter") }, 35)

                if (gsKey.equals("gravar")) {

                    gravarProduto(_produto, _qtd, _inProdutoQtd)
                    _table1Controler.json(
                        JSON.stringify(Fatloteitem().countMax(llote)).ffJsonParse(false)
                    )

//                    _table1Controler.json(JSON.stringify(countMax()).ffJsonParse(false))
                    gsKey = ""
                }

                ffButtonDiv("Cancel", {
                    _btAbrir.enabled(true)
                    _produto.clear()
                    _produto.enabled(true)
                    _inProdutoQtd.clear()
                    _inProdutoQtd.textAnt("1")
                    _produto.setFocus()
                }, 12)

            }
        }

        //listarFatlote(_lote)


        if (!_table1Controler.json().equals("")) {
            Div() {

                val lcon = ArrayList<table1>()
                lcon.add(table1().add(80, "S", "N", "OO_PRODUTO       ", "Produto"))
                lcon.add(table1().add(20, "N", "N", "FATITE_QTDE      ", "Qtde."))
                lcon.add(table1().add(20, "N", "N", "OO_QTDFALTA      ", "Falta"))
                table1().ffTable1(
                    lcon,
                    _table1Controler = _table1Controler,
                    _tbTipo = "Black"
                )
            }
        }

        if (_produto.enabled())
            _produto.setFocusSimples(true)


    }


    //*********************************************************************************************** FUNCOES E
    private fun gravarProduto(
        _produto: MutableState<String>,
        _qtd: MutableState<String>,
        _inProdutoQtd: MutableState<String>
        //_table1Controler: MutableState<String>
    ) {
        try {
            println0("try gravarProduto ${_produto.text()}")

            if (_produto.text().ffCopy(1, 6).ffVsi() != 0 && llote != null) {
                val iProd = _produto.text().ffCopy(1, 6).ffVsi()
                olote = llote!!.filter({ p -> p.FATITE_PRODUTO == iProd }).getOrNull(0)

                if (olote != null && olote!!.FATITE_PRODUTO == iProd) {
                    //val fNovaQtd = ff.ffVsd(_produto.text()).times(oinvIte!!.ESTG_UNIDVENDA)
                    val dQuant = _qtd.text().ffVsdo() * _inProdutoQtd.textAnt().ffVsdo()
                    olote!!.FATITE_QTCONT += dQuant
                    olote!!.OO_QTDFALTA = olote!!.FATITE_QTDE - olote!!.FATITE_QTCONT
                    olote!!.OO_DATACONT = Date()
                    ffMsgAviso("quantidade88 falta = ${olote!!.OO_QTDFALTA}", false)
                    Service().postGen(olote!!.asDynamic(), "${ff.gsDom1}/fatlote/014/item") { obj ->
                        if (obj.PAD_CODIGO.compareTo(200) == 0) {
                            ffMsgAviso("Gravado")
                            _produto.text("")
                            _qtd.text("1")
                            _qtd.span("Qtd:")

                        } else {
                            ffMsgAviso("Erro!", true)
                            print("erro ${obj.PAD_CODIGO}")
                        }
                        _produto.setFocus("true")
                    }
                } else {
                    ffMsgAviso("Informe o produto!", true)
                    _produto.atualizar()
                }
            }
            _produto.clear()
            _produto.enabled(true)
            _inProdutoQtd.textAnt("1")
            //_produto.inputRecar()
        } catch (e: Exception) {
            ffMsgAviso("Erro! ${e.message}", true)
        }
    }

    private fun listarFatlote(_lote: MutableState<String>, _table1Controler: MutableState<String>): Unit {


        if (!_lote!!.value.equals("")) {
            Fatloteitem().getFatloteItens(_lote!!.text()) { lobj ->
                println0(lobj)
                llote = lobj
                if (lobj.size == 0) {
                    ffMsgAviso("Lote não encontrado ${_lote!!.text()}, certifique de ter impresso a lista de separação, no retaguarda.")
                } else {

//                    _table1Controler.json(JSON.stringify(countMax())).ffJsonParse(false)
                    _table1Controler.json(
                        JSON.stringify(Fatloteitem().countMax(llote)).ffJsonParse(false)
                    )


//                    _table1Controler.json(
//                        JSON.stringify(llote!!.filter({ p -> p.FATITE_QTDE != p.FATITE_QTCONT })).ffJsonParse(false)
//                    )
                }

            }

        }
    }


}